import gql from 'graphql-tag';

export const EMPLOYEE_USER_COUNT = gql`
  query me {
    me {
     id
     employee{
        id
        teamManagerEmployee{
            totalCount
        }
        orgCeoEmployee{
            totalCount
        }
        orgPocEmployee{
            totalCount
        }
        verticalHeadEmployee{
            totalCount
        }
     }
    }
  }
`;